import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error(`
        ❌ ERRO CRÍTICO: Variáveis de ambiente do Supabase não encontradas!
        Verifique se o arquivo .env.local existe e se as chaves começam com VITE_.
        
        Valores atuais:
        URL: ${supabaseUrl ? 'Definido' : 'AUSENTE'}
        KEY: ${supabaseAnonKey ? 'Definido' : 'AUSENTE'}
    `);
    throw new Error('As variáveis de ambiente do Supabase não foram configuradas. Verifique o console para mais detalhes.');
}

// Initializing with URL: ${supabaseUrl}
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
